import React, { useMemo, useState, useEffect, useContext } from "react";
import "./style.css";

import { ClientPicker, ReactTable } from "../../Components/Molecules";
import { VIEW_GEOFENCES_HEADERS } from "../../Library/tableHeaders";
import { getFilters } from "../../Library/tableHelpers";
import { Link, useNavigate } from "react-router-dom";
import PATHS from "../../Routes/paths";
import { Breadcrumb, PopUpModal } from "../../Components/Atoms";
import { Button, IconButton, useToast } from "@chakra-ui/react";
import { AddIcon, DeleteIcon, EditModelIcon } from "../../Assets/images/svgs";
import { removeGeofence, getGeofencesByClient } from "../../APIs";
import { StoreContext } from "../../Library/contexts";

const ViewGeofences = () => {
  const Toast = useToast();
  const navigate = useNavigate();
  const { filters } = useContext(StoreContext);

  const breadcrumbPaths = [
    { idx: 1, name: "Lease", link: PATHS.LEASE },
    { idx: 2, name: "Vehicles", link: PATHS.LEASED_VEHICLES },
    { idx: 2, name: "View Geofences", isCurrentPage: true },
  ];

  const [ clientGeofences, setClientGeofences ] = useState([ ]);
  const [ showConfirmModal, setShowConfirmModal ] = useState(null);

  const deleteGeofence = async (geofenceId) => {
    removeGeofence({ idx: geofenceId, clientId: filters.client }, (error) => {
      if (error) {
        console.error(error);
        Toast({ isClosable: true, description: error || "Something went wrong", position: "bottom", variant: "subtle", duration: 3000 });
        setShowConfirmModal(false);
      } else {
        Toast({ isClosable: true, description: "Geofence deleted successfully", position: "bottom", variant: "left-accent", duration: 3000 });
        setClientGeofences(clientGeofences.filter(fence => fence.idx !== geofenceId));
        setShowConfirmModal(false);
      }
    });
  }

  const confirmGeofenceDelete = (geofenceId) => {
    setShowConfirmModal({
      open: true,
      modalMsg: "Are you sure you want to delete this geofence ?",
      closeBtn: "Cancel",
      confirmBtn: "Yes",
      onConfirm: () => deleteGeofence(geofenceId),
      onModalClose: () => setShowConfirmModal(false),
    })
  }

  const columns = useMemo(() => Object.values(VIEW_GEOFENCES_HEADERS).map(header => {
    return {
      Header: header.nm,
      accessor: header.key,
      disableSortBy: !header.sorting,
      Cell: (row) => {
        if (header.navigate) {
          return <Link className="text-blue" to={`${PATHS.ADD_GEOFENCE}?idx=${row.row.original.idx}`} >{row.value}</Link>
        }

        if (header.edit) {
          return (
            <div className="update-geofence-buttons">
              <IconButton className="edit-geofence-button" onClick={() => navigate(`${PATHS.ADD_GEOFENCE}?idx=${row.row.original.idx}`)} icon={<EditModelIcon />} />
              { header.delete ? <IconButton className="delete-geofence" onClick={() => confirmGeofenceDelete(row.row.original.idx)} icon={<DeleteIcon />} /> : null }
            </div>
          )
        }

        return row.value || "-";
      },
      ...getFilters(header),
    };
  }), [ clientGeofences ]);

  const fetchClientGeofences = async (clientId) => {
    try {
      const geoFences = await getGeofencesByClient(clientId);
      setClientGeofences(geoFences);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (filters.client && !clientGeofences.length) {
      fetchClientGeofences(filters.client);
    }

  }, [ filters.client ])

  return (
    <div className="panel-main view-geofences">
      <header>
        <Breadcrumb paths={breadcrumbPaths} />
        <ClientPicker />
      </header>

      <Button onClick={() => navigate(PATHS.ADD_GEOFENCE)} className="add-geofence-button">
        <AddIcon />
        Add geofence
      </Button>

      <ReactTable
        columns={columns}
        data={clientGeofences}
        showSearch={true}
        showOverlay={false}
        heading="Geofences"
        pageSize={4}
      />

      <PopUpModal { ...showConfirmModal } />
    </div>
  )
}

export default ViewGeofences